<header class="site-page-header">
  <div class="site-page-header__intro">
    <div class="site-page-header__copy">
      <h1 class="site-page-header__title">{{ titleKey | translate }}</h1>
      <p class="site-page-header__description" *ngIf="description">{{ description | translate }}</p>
      <ng-content select="[site-page-header-context]"></ng-content>
      <div class="site-page-header__links" *ngIf="showBack || siteName">
        <button *ngIf="showBack" type="button" class="site-page-header__back" (click)="backClick.emit()"><span class="site-page-header__back-icon"><i class="bi bi-arrow-left" aria-hidden="true"></i></span>{{ backLabel | translate }}</button>
        <button *ngIf="siteName" type="button" class="site-page-header__store" (click)="siteClick.emit()" [disabled]="!siteLinkEnabled" [attr.aria-label]="('bo_view_store' | translate) + ': ' + siteName">
          <i class="bi bi-shop-window" aria-hidden="true"></i>
          <span class="site-page-header__store-label">{{ 'bo_view_store' | translate }}</span>
          <span class="site-page-header__store-name">{{ siteName }}</span>
          <i class="bi bi-arrow-up-right site-page-header__external" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="site-page-header__actions"><ng-content select="[site-page-header-actions]"></ng-content></div>
</header>
